import { render, staticRenderFns } from "./CustomerOverdueTable.vue?vue&type=template&id=91171a24"
import script from "./CustomerOverdueTable.vue?vue&type=script&lang=ts"
export * from "./CustomerOverdueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports